/**
 * The tallest a one-row text-box toolbar is: the 4px padding around a 32px
 * field, with slack for a hairline. Every control keeps its desktop form, so
 * a canvas too narrow for the row (a 13" laptop's 780px canvas) wraps the
 * toolbar to a second row instead; the page's offset below makes room for it.
 */
export const EDITOR_TOOLBAR_ONE_ROW_MAX_PX = 44

/**
 * Where the toolbar strip hangs from the canvas top.
 */
export const EDITOR_TOOLBAR_STRIP_TOP_PX = 14

/**
 * The page's offset from the canvas top: a two-row toolbar ends 92px down
 * (the strip's 14px, then 4px padding, two 32px rows and 6px between them),
 * and the page starts 6px under it. Fit-to-view (`fitToView` in `useZoom.js`)
 * fits the page between this offset and the bottom toolbar's top edge, so a
 * larger offset lowers the zoom of a page whose height limits the fit: a
 * smaller fit leaves a short box's side pills under its corner hotspots on
 * screen.
 */
export const EDITOR_CANVAS_PAGE_TOP_PX = 98

/**
 * The colour tile grid's width: five 30px tiles a row, TinyMCE's swatch
 * grid. The outline colour flyout and the shadow menu are this wide while
 * they show the tiles.
 */
export const EDITOR_COLOR_TILE_GRID_WIDTH_PX = 150

/**
 * How much further in than its group row's label the label of a row under
 * a group of the insert-detail menu starts, so a child reads as the group's
 * and not as a sibling of it.
 */
export const EDITOR_FIELD_MENU_CHILD_INDENT_PX = 16
